import { setLanguageFile, trans as ai18nTrans } from '@clickbar/ai18n';
import { setLanguageFile as setTuiLanguageFile } from '@clickbar/tailwindui-vue';
import { useTextDirection } from '@vueuse/core';
import { ref, type Plugin } from 'vue';

const currentLanguageCode = ref('de');

const langs = import.meta.glob('../../lang/*.json');

export async function loadLanguageFile(languageCode: string) {
  const languageFile = (await langs[`../../lang/${languageCode}.json`]()) as {
    default: Record<string, string>;
  };
  setLanguageFile(languageCode, languageFile.default);
  setTuiLanguageFile(languageFile.default);

  currentLanguageCode.value = languageCode;
}

export function trans(
  key: string,
  replacements?: Record<string, string | number> & { n?: number },
) {
  // we just want to trigger the getter.
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  currentLanguageCode.value;
  return ai18nTrans(key, replacements);
}

export const textDirection = useTextDirection();

export function setLocale(locale: string) {
  void loadLanguageFile(locale);
  textDirection.value = locale === 'ar' ? 'rtl' : 'ltr';
}

export const i18nVue: Plugin = {
  install: (app) => {
    app.config.globalProperties.$t = (
      key: Parameters<typeof ai18nTrans>[0],
      replacements?: Parameters<typeof ai18nTrans>[1],
    ) => trans(key, replacements);
  },
};

declare module 'vue' {
  interface ComponentCustomProperties {
    $t: typeof trans;
  }
}
